import classNames from 'classnames'
import React from 'react'

import { Loader } from './Loader'

export interface LoaderWrapperProps {
  showLoader?: boolean
  minHeight?: string
  children?: React.ReactNode
  loadWrapperClassName?: string
  containerClassName?: string
  childrenClassName?: string
  testid?: string
}

const hideElementOnLoader = {
  display: 'none',
}

const LoaderWrapper = ({
  testid,
  showLoader,
  minHeight = '31rem',
  children,
  loadWrapperClassName,
  containerClassName,
  childrenClassName,
}: LoaderWrapperProps) => {
  return (
    <div data-testid={testid} className={classNames(containerClassName)}>
      <Loader showLoader={showLoader} minHeight={minHeight} loadWrapperClassName={loadWrapperClassName} />
      <div className={classNames(childrenClassName)} style={showLoader ? hideElementOnLoader : undefined}>
        {children}
      </div>
    </div>
  )
}

export default LoaderWrapper
